<template>
  <!--   <section class="cart-wrap">
    <div class="container">
      <div class="side-cart-wrap cart-page">
        <div class="head">
          <div class="cart">
            My Shopping Cart
            <span :class="showObject">is Empty !</span>
          </div>
        </div>
        <div class="empty" :class="showObject">
          <div class="img-wrap">
            <img src="../../assets/images/cart-empty.webp" alt="emptyCart" />
          </div>
          <div class="text-content">{{ getStaticAt(6, "en") }}</div>
        </div>
        <div class="cart-items-wrap" :class="showObject">
          <div class="cart-items">
            <div class="header">
              <div class="item-name">Item</div>
              <div class="item-price"></div>
              <div class="item-quantity">Qty</div>
              <div class="item-total">Total</div>
              <div class="item-action">
                Remove
                <span>item</span>
              </div>
            </div>
            <div
              class="cart-item-content"
              v-for="item in cartItems"
              :key="item.id"
            >
              <div class="item-info">
                <div class="food-name">{{ item.name }}</div>
              </div>
              <div class="price">NRs {{ item.after_price }}</div>
              <div class="order-button-wrap">
                <div class="added">
                  <a-button
                    class="order-button minus"
                    icon="minus"
                    @click="minusQuantity(item.id)"
                  />
                  {{ item.quantity }}
                  <a-button
                    class="order-button plus"
                    icon="plus"
                    @click="addQuantity(item.id)"
                  />
                </div>
              </div>
              <div class="total price">
                NRs {{ item.after_price * item.quantity }}
              </div>
              <div class="remove-item">
                <a-popconfirm
                  title="Are you sure delete this item?"
                  @confirm="deleteItem(item.id)"
                  @cancel="cancel"
                  okText="Yes"
                  cancelText="No"
                >
                  <a-icon type="delete" />
                </a-popconfirm>
              </div>
            </div>
          </div>
          <div class="subtotal">
            <div class="total-price">
              <div class="text">Subtotal</div>
              <div class="price">
                <span>NRs {{ cartTotal }}</span>
              </div>
            </div>
            <div class="total-price discount-info" v-if="showDiscount">
              <div class="text">Your Discount</div>
              <div class="discount">
                <span>- {{ this.getPromoDiscount }}%</span>
              </div>
            </div>
            <div class="total-price with-discount" v-if="showDiscount">
              <div class="text">New Total</div>
              <div class="price">
                <span>NRs {{ this.getPromoDiscountTotal }}</span>
              </div>
            </div>
            <div class="extra-charge">
              Delivery Charge will be applied accordingly.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <div>
    <nav class="breadcrumb">
      <ul>
        <li><a @click.prevent="handleBreadcumb0()" class="active">Cart</a></li>
        <li><a @click.prevent="handleBreadcumb0()">Location</a></li>
        <li><a @click.prevent="handleBreadcumb0()">Delivery</a></li>
        <li><a @click.prevent="handleBreadcumb0()">Payment</a></li>
      </ul>
    </nav>
    <!-- <p>{{ getPromoInfo }}</p> -->
    <main>
      <div class="main-left">
        <div class="cart">
          <p class="title">My Shopping Cart</p>
          <div class="cart-content">
            <div class="emptyCart" v-if="Object.keys(cartItems).length === 0">
              <p>Your Cart is Empty</p>
              <button @click="onHome">Order Now</button>
            </div>
            <div class="cartList" v-for="item in cartItems" :key="item.id">
              <div>
                <img
                  v-if="!item.image"
                  class="cartListImg"
                  src="../../assets/images/default-img.jpg"
                />

                <img
                  v-else
                  class="cartListImg"
                  :src="item.image"
                  :alt="item.name"
                />
              </div>
              <div class="cartListInfo">
                <div class="cartListInfo-top">
                  <p>{{ item.name }}</p>
                </div>
                <div class="cartListInfo-bottom">
                  <p class="price">NRs. {{ item.after_price }}</p>
                  <p class="qty">
                    <a-icon
                      type="minus"
                      class="minus"
                      icon="minus"
                      @click="minusQuantity(item.id)"
                    />
                    {{ item.quantity }}
                    <a-icon
                      type="plus"
                      class="plus"
                      icon="plus"
                      @click="addQuantity(item.id)"
                    />
                  </p>
                  <p class="total">
                    NRs. {{ item.after_price * item.quantity }}
                  </p>
                </div>
              </div>
              <div class="remove-item">
                <a-popconfirm
                  title="Are you sure delete this item?"
                  @confirm="deleteItem(item.id)"
                  @cancel="cancel"
                  okText="Yes"
                  cancelText="No"
                >
                  <a-icon type="close" class="close" />
                </a-popconfirm>
              </div>
              <!-- <a-icon type="close" class="close" /> -->
            </div>
          </div>
        </div>

        <div class="cart">
          <p class="title">Would You Like To Add</p>
          <div v-for="item in pushSellItems" :key="item.id">
            <SuggestItem v-bind:item="item" :key="item.id" />
          </div>
        </div>

        <!-- RECOMMENDATION WAS HERE -->
      </div>
      <div class="main-right">
        <div class="order-summary">
          <p class="title">Order Summary</p>

          <div class="calculations">
            <p>Subtotal</p>
            <p>NRs. {{ cartTotal }}</p>
          </div>

          <!-- <div class="coupon-code">
            <button class="promo-button" @click="handleCouponForm">
              I Have a Coupon <a-icon type="gift" class="gift-icon" />
            </button>
            <div v-if="showCouponForm">
              <form
                class="promo-form"
                v-if="!this.promoInfo.status"
                @submit="sendPromo"
              >
                <input
                  class="promo-input"
                  type="varchar"
                  placeholder="Enter Coupon"
                  name="coupon"
                  id="coupon"
                  v-model="coupon"
                />
                <input class="promo-submit-btn" type="submit" value="Apply" />
              </form>

              <div v-else class="discount-details-wrapper">
                <span class="discounts-header">Coupon Discount Applied!</span>
                <div class="discounts-info">
                  <span v-if="this.promoInfo.description">
                    {{ this.promoInfo.description }}
                  </span>
                  <span v-if="this.promoInfo.cookedFood > 0">
                    {{ this.promoInfo.cookedFood }}% Discount in Food Items.
                  </span>
                  <span v-if="this.promoInfo.mart > 0">
                    {{ this.promoInfo.mart }}% Discount in Mart Items.
                  </span>
                  <span v-if="this.promoInfo.bakery > 0">
                    {{ this.promoInfo.bakery }}% Discount in Bakery Items.
                  </span>
                  <span v-if="this.promoInfo.liquor > 0">
                    {{ this.promoInfo.liquor }}% Discount in Liquor Items.
                  </span>
                  <span v-if="this.promoInfo.deliveryCharge >= 0"
                    >Delivery Charge Rs
                    {{ this.promoInfo.deliveryCharge }}.</span
                  >
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div
            class="category-price-container calculations"
            v-if="this.promoInfo.status === true"
          >
            <p class="category-text">Discount:</p>
            <div>
              <p class="category-price">
                NRs. {{ this.cartTotal - this.getPromoDiscountTotal }}
              </p>
            </div>
          </div>

          <div
            class="category-price-container calculations"
            v-if="this.vat !== 0"
          >
            <p class="category-text">VAT(13%):</p>
            <p class="category-price">NRs. {{ this.vat }}</p>
          </div>

          <div
            class="category-price-container calculations"
            v-if="this.intlTransfer !== 0"
          >
            <p class="category-text">International Transfer Charge(5.1%):</p>
            <p class="category-price">NRs. {{ this.intlTransfer }}</p>
          </div> -->

          <div class="total-price-container calculations">
            <!-- <p class="total-price">Total Amount:</p> -->

            <!-- <p class="total-price">
              NRs.
              {{
                (this.getPromoDiscountTotal === 0
                  ? this.cartTotal
                  : this.getPromoDiscountTotal) +
                this.delCharge +
                this.vat +
                this.intlTransfer
              }}
            </p> -->

            <!-- <p class="total-price">NRs. {{ this.cartTotal }}</p> -->
          </div>

          <p class="note"><span> ++ Delivery Charge</span></p>
        </div>
        <div class="buttons">
          <a
            ><button @click.prevent="handleContinueShopping()">
              <a-icon type="shopping-cart" />ADD MORE ITEMS
            </button></a
          >
          <a>
            <button @click.prevent="handleCheckout()">
              SELECT DELIVERY LOCATION
            </button>
          </a>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { data } from "./data";
import { mapGetters, mapActions } from "vuex";
import { LocationId, CartData } from "../../services/storage.service";
import router from "../../router";
import { UserService } from "../../services/user.service";
import axios from "axios";
import SuggestItem from "../../views/Home/ProductFeature/SuggestItem.vue";

export default {
  name: "Cart",
  components: {
    SuggestItem,
  },
  data() {
    return {
      data,
      showDiscount: false,
      display: "none",
      cartQuantity: 0,
      coupon: "",
      showCouponForm: false,
      promoInfo: {
        // status: false,
        // description: "",
        // deliveryCharge: "",
        // cookedFood: "",
        // mart: "",
        // bakery: "",
        // liquor: "",
      },
      delCharge: 0,
      pushSellItems: [],
      // items: {
      //   after_price: 100,
      //   banner_image_url: "",
      //   before_price: "",
      //   cat_id: "beverages",
      //   cs_tags: "Out of Stock",
      //   id: 1308,
      //   image: "https://khaanpin.com/images/shop/coke_1.jpg",
      //   img: "shop/coke_1.jpg",
      //   item_type: "single",
      //   name: "Coke, 500ml",
      //   rating: 5,
      //   short_description:
      //     "Coca-Cola is the most popular and biggest-selling soft drink in history, as well as one of the most recognizable brands in the world.  Created in 1886 in Atlanta, Georgia, by Dr. John S. Pemberton, Coca-Cola was first offered as a fountain beverage at Jacob's Pharmacy by mixing Coca-Cola syrup with carbonated water.  Coca-Cola is Number One Sparkling Brand in Nepal today.",
      //   sub_cat_id: "soft drinks/water",
      //   tags: "",
      // },
      add: false,
      mobileView: false,

      allItems: [],
      newTotal: 0,
      intlTransfer: 0,
      vat: 0,

      dis: 0,
      quantity: 1,
      minimumOrder: 500,
    };
  },
  created() {
    // let quantity = this.cartItems.reduce((acc, item) => acc + item.quantity, 0);
    // this.cartQuantity = quantity;

    this.getPushSellItems();
    this.getMinimumOrder();
  },
  watch: {
    // whenever question changes, this function will run
    /*     cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
    }, */
    // cartItems: function (val) {
    //   // let quantity = val.reduce((acc, item) => acc + item.quantity, 0);
    //   // this.cartQuantity = quantity;
    // },

    cartItems: function (newCartItems, oldCartItems) {
      CartData.setCartItems(newCartItems);
      if (newCartItems.length === 0) {
        (this.add = false), (this.quantity = 1);
        return;
      } else if (
        newCartItems.filter((food) => food.id === this.itemId).length === 0
      ) {
        (this.add = false), (this.quantity = 1);
        return;
      } else {
        this.quantity = newCartItems.filter(
          (food) => food.id === this.itemId
        )[0].quantity;
      }
    },
    getPromoDiscount: function (newDiscount, oldDiscount) {
      if (newDiscount > 0) {
        this.showDiscount = true;
      } else {
        this.showDiscount = false;
      }
    },
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "cartTotal",
      "getPromoDiscountTotal",
      "getPromoDiscount",
      "systemStaticTexts",
      "getPromoInfo",
    ]),
    showObject: function () {
      return {
        show: this.cartItems.length === 0,
      };
    },
  },
  methods: {
    ...mapActions([
      "addToCart",
      "addQuantity",
      "minusQuantity",
      "deleteItem",
      "updateStep",
      "addDiscount",
      "addCFDiscount",
      "addMDiscount",
      "addBDiscount",
      "addLDiscount",
      "addPromoCode",
      "applyDeliveryCharge",
      "setPromoInfo",
      "addPromoDiscount",
    ]),

    addToCartCall(item) {
      this.add = !this.add;
      this.addToCart(item);
    },
    increaseQuantity(id) {
      this.addQuantity(id);
    },
    decreaseQuantity(id) {
      if (this.quantity === 1) {
        this.add = false;
        this.deleteItem(id);
      } else {
        this.minusQuantity(id);
      }
    },

    cancel(e) {
      return;
    },

    getStaticAt: function (id, ln) {
      let staticText = this.systemStaticTexts.filter((item) => item.id == id);
      return staticText[0]["value_" + ln];
    },
    handleContinueShopping() {
      router.push("/:loc?");
    },
    onHome() {
      router.push("/");
    },

    handleCheckout() {
      if (this.cartTotal < this.minimumOrder) {
        this.$message.warning(
          `Cart should be atleast of NRs. ${this.minimumOrder}`
        );
      } else {
        this.updateStep(1);
      }
    },
    handleBreadcumb0() {
      this.updateStep(0);
    },
    handleCouponForm() {
      this.showCouponForm = !this.showCouponForm;
    },
    sendPromo(e) {
      e.preventDefault();

      this.addPromoCode(this.coupon);

      UserService.promoSend(this.coupon)
        .then((data) => {
          const DATA = data.data;

          if (data.error === false) {
            this.promoInfo.status = true;
            this.promoInfo.description = DATA.description;

            this.promoInfo.deliveryCharge = DATA.delivery_charge;

            this.promoInfo.cookedFood = DATA.cooked_food;
            this.promoInfo.mart = DATA.mart;
            this.promoInfo.bakery = DATA.bakery;
            this.promoInfo.liquor = DATA.liquor;

            this.addCFDiscount(DATA.cooked_food);
            this.addMDiscount(DATA.mart);
            this.addBDiscount(DATA.bakery);
            this.addLDiscount(DATA.liquor);

            if (DATA.delivery_charge >= 0) {
              CartData.setDeliveryCharge(DATA.delivery_charge);
              this.applyDeliveryCharge(DATA.delivery_charge);
              this.delCharge = DATA.delivery_charge;
            }

            this.getCartItemsCategories(e);
          } else {
            this.$notification.error({
              message: "Promo Code is not valid",
              description: "Please confirm your promo code as it is not valid.",
            });
          }
        })
        .catch((err) => console.log(err));

      this.setPromoInfo(this.promoInfo);
    },

    getCartItemsCategories(e) {
      e.preventDefault();

      // cart items
      const cData = CartData.getCartItems();

      // adding item section
      let cartCat = cData.map((obj) => {
        const index = this.allItems.findIndex((el) => el["id"] == obj["id"]);
        const { section } = index !== 1 ? this.allItems[index] : {};

        return {
          ...obj,
          section,
        };
      });

      // group items according to category
      const groupCategories = cartCat.reduce((acc, cV) => {
        acc[cV.section] = acc[cV.section] || [];
        acc[cV.section].push(cV);
        return acc;
      }, Object.create(null));

      // calculate category total
      let totalObj = this.getCatTotal(groupCategories);

      // adding category discount %
      let discountObj = this.createDiscountObj();

      // merging two datasets
      let mergedObj = totalObj.map((item) => ({
        ...item,
        ...discountObj.find((innerItem) => innerItem.cat === item.cat),
      }));

      /* calculate cart total
        returns total if dis is empty
        returns discounted total if dis available
      */
      const catTotal = mergedObj.reduce(
        (sum, { cat_total, dis }) => sum + this.calcCatDiscount(cat_total, dis),
        0
      );

      this.newTotal = catTotal;
      this.addDiscount(catTotal);
    },

    async getItems() {
      let allData = [];
      let morePagesAvailable = true;
      let currentPage = 0;

      while (morePagesAvailable) {
        currentPage++;
        const response = await axios.post(
          // "https://manager.khaanpin.com/api/getitemsv2/",
          "https://deus.khaanpin.com/om/getitemsv2/",

          {
            loc_id: LocationId.getLocationId(),
            page: currentPage,
          }
        );

        let { data, page_count } = response.data;
        data.forEach((e) => allData.push(e));
        morePagesAvailable = currentPage < page_count;
      }

      const result = allData.map((data) => ({
        id: data.id,
        section: data.section,
      }));

      this.allItems = result;
    },

    getCatTotal(array) {
      var newData = [];

      Object.entries(array).forEach((entry) => {
        const [key, value] = entry;
        let cat_total = this.calcCatTotal(value);

        newData.push({ cat: key, cat_total });
      });

      return newData;
    },

    calcCatTotal(array) {
      const categoryTotal = array.reduce(
        (sum, { after_price, quantity }) => sum + after_price * quantity,
        0
      );
      return categoryTotal;
    },

    createDiscountObj() {
      let disObj = [];

      disObj.push(
        { cat: "cooked-food", dis: this.promoInfo.cookedFood },
        { cat: "mart", dis: this.promoInfo.mart },
        { cat: "bakery", dis: this.promoInfo.bakery },
        { cat: "drinks", dis: this.promoInfo.liquor }
      );

      return disObj;
    },

    calcCatDiscount(total, discount) {
      const discountedPrice = Math.ceil(total - (discount / 100) * total);
      return discountedPrice;
    },

    getPushSellItems() {
      axios
        .post("https://deus.khaanpin.com/appapi/pushsell/", {
          loc_id: JSON.stringify(LocationId.getLocationId()),
        })
        .then((response) => {
          if (!response.data.error) {
            this.pushSellItems = response.data.data;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },

    getMinimumOrder() {
      axios
        .post("https://deus.khaanpin.com/appapi/minimumorder/", {
          loc_id: JSON.stringify(LocationId.getLocationId()),
        })
        .then((response) => {
          if (!response.data.error) {
            this.minimumOrder = response.data.data.charge;
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
  beforeMount() {
    // this.getUserRegion();
    this.getItems();
    // this.getUserTimezone();
    // this.getDeliveryCharge();
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

// new css
// variables
$theme-color: #ed2027;
$font-color: #706b6b;
$detail-color: #333;
$success-color: #60b246;
$info-color: #2e89d3;

$button-size: 16px;
$text-size: 16px;
$icon-size: 20px;
$heading-size: 24px;
$display-size: 36px;

$border: 1px solid rgba(3, 3, 3, 0.3);
$border-radius: 10px;

nav {
  max-width: 60rem;
  margin: 0px auto 20px;
  ul {
    list-style: none;
    li {
      display: inline;
      + li:before {
        content: ">";
        padding: 10px;
      }
      a {
        text-decoration: none;
        color: $font-color;
        font-size: $icon-size;
        text-transform: uppercase;
        color: $font-color;
        padding: 5px 10px;
        &:hover {
          opacity: 0.8;
          transition: all ease-in-out 0.3s;
        }
      }
      .active {
        color: $theme-color;
        font-weight: bold;
      }
    }
  }
}
main {
  width: 60rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 0.6fr;
  grid-gap: 20px;
  hr {
    opacity: 0.3;
  }
  p {
    font-size: $text-size;
    color: $detail-color;
  }
  .main-left {
    .cart {
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      height: auto;
      // min-height: 400px;
      max-height: 400px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      padding: 20px;
      width: auto;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      margin-bottom: 40px;
      overflow-y: scroll;
      .title {
        font-size: $heading-size;
        font-weight: bold;
        color: $detail-color;
        margin-bottom: 20px;
        /*         position: sticky;
        top: 0; */
      }
      .cart-content {
        // margin-top: 60px;
        .emptyCart {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: rgba(190, 193, 196, 0.1);
          height: 19rem;
          border-radius: $border-radius;
          margin-top: -60px;

          p {
            font-size: $heading-size;
            font-weight: bold;
            color: rgb(154, 157, 160);
          }
          button {
            background-color: #ed3c3b;
            border: none;
            font-size: 16px;
            font-weight: bolder;
            color: white;
            padding: 8px 18px;
            border-radius: 15px;
            margin-top: -10px;
          }
          button:hover {
            background-color: #ff0000;
            color: white;
          }
        }

        .cartList {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 8px 0;
          border-radius: $border-radius;
          // margin: 10px 0 -10px;
          img {
            height: 60px;
            width: 60px;
            border-radius: $border-radius;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
          }
          .cartListInfo {
            margin: 0 60px 0 30px;
            flex-basis: 80%;
            display: flex;
            flex-flow: column nowrap;
            .cartListInfo-top {
              p {
                font-size: $text-size;
                font-weight: bold;
                margin-bottom: 20px;
              }
            }
            .cartListInfo-bottom {
              display: flex;
              justify-content: space-between;
              .qty {
                border: $border;
                border-radius: $border-radius;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .minus {
                  margin: 0 15px 0 10px;
                  color: $font-color;
                  &:hover {
                    cursor: pointer;
                  }
                }
                .plus {
                  color: $success-color;
                  margin: 0 10px 0 15px;
                  &:hover {
                    cursor: pointer;
                  }
                }
              }
              .total {
                font-weight: bold;
              }
            }
          }
          .close {
            color: $theme-color;
            text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
            &:hover {
              text-shadow: none;
              cursor: pointer;
              transition: all ease-in-out 0.3s;
              opacity: 0.8;
            }
          }
        }
      }
    }
    .recommendation {
      margin-top: 20px;
      width: auto;
      .title {
        color: $detail-color;
        margin: 0 0 5px 5px;
      }
      .recommended-item {
        border-radius: $border-radius;
        padding: 20px;
        width: auto;
        box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
        .cartList {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 8px 0;
          border-radius: $border-radius;
          // background-color: rebeccapurple;
          img {
            height: 60px;
            width: 60px;
            border-radius: $border-radius;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
          }
          .cartListInfo {
            // margin: 0 30px;
            // background-color: red;
            flex-basis: 40%;
            .cartListInfo-top {
              color: #333;
              span {
                display: inline-block;
                font-weight: bold;
                font-size: $button-size;
                &:last-child {
                  margin-bottom: 10px;
                }
              }
              p {
                font-size: $text-size;
                font-weight: bold;
                margin-bottom: 20px;
              }
            }
            .cartListInfo-bottom {
              color: #333;
              font-weight: bold;
              font-size: $button-size;
            }
          }
          .order-button-wrap {
            flex-basis: 20%;
            // background-color: rebeccapurple;
            .add {
              background-color: $success-color;
              color: #fff;
              text-align: center;
              border-radius: $border-radius;
              width: 80px;
              padding: 5px 10px;
              &:hover {
                cursor: pointer;
              }
            }
            .qty {
              border: $border;
              border-radius: $border-radius;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .minus {
                margin: 0 10px;
                color: $font-color;
                &:hover {
                  cursor: pointer;
                }
              }
              .plus {
                color: $success-color;
                margin: 0 10px;
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
          button {
            align-self: center;
            margin: 0 30px 0 0;
            background-color: $success-color;
            border: none;
            outline: none;
            padding: 10px 30px;
            border-radius: $border-radius;
            color: #fff;
            font-size: $button-size;
            &:hover {
              cursor: pointer;
              opacity: 0.9;
              transition: all ease-in-out 0.3s;
            }
          }
          .close {
            color: $theme-color;
            text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
            &:hover {
              text-shadow: none;
              cursor: pointer;
              transition: all ease-in-out 0.3s;
              opacity: 0.8;
            }
          }
        }
      }

      .next {
        margin-top: 10px;
        text-align: right;
        &:hover {
          cursor: pointer;
        }
        a {
          color: $font-color;
          margin-top: 5px;
          text-decoration: underline;
        }
      }
    }
  }
  .main-right {
    .order-summary {
      border-radius: $border-radius;
      width: auto;
      padding: 20px;

      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      .title {
        font-size: $heading-size;
        color: $detail-color;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .calculations {
        display: flex;
        justify-content: space-between;
      }
      /*       .coupon-code {
        p {
          text-align: right;
          margin: 10px 0;
          color: $detail-color;
          text-decoration: underline;
          &:hover {
            cursor: pointer;
          }
        }
        .couponCode {
          // background-color: rebeccapurple;
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          input {
            flex-basis: 85%;
            outline: none;
            border: $border;
            padding: 10px;
            border-radius: $border-radius 0 0 $border-radius;
          }
          button {
            padding: 10px 20px;
            background-color: $success-color;
            outline: none;
            border: $border;
            color: #fff;
            border-radius: 0 $border-radius $border-radius 0;
            &:hover {
              opacity: 0.8;
              transition: all ease-in-out 0.3s;
            }
          }
        }
      } */

      .coupon-code {
        margin-bottom: 10px;
        button {
          width: 100%;
        }
        form {
          // background-color: rebeccapurple;
          display: flex;
          justify-content: center;
          align-items: center;
          input[type="varchar"] {
            flex: 1 1 auto;
          }
          input[type="submit"] {
            padding: 0 20px;
          }
        }
      }

      .discount-details-wrapper {
        margin: 5px 0 10px;
        text-align: center;
        color: $detail-color;
        .discounts-header {
          font-weight: bold;
        }
        .discounts-info {
          margin-top: 5px;
          span {
            display: block;
          }
        }
      }
      .note {
        text-align: right;
        font-size: 12px;
        span {
          color: #646464;
        }
      }
    }
    .buttons {
      padding: 20px;
      margin-top: 20px;
      box-shadow: 0px 2px 5px rgba(3, 3, 3, 0.3);
      border-radius: $border-radius;
      display: flex;
      flex-flow: column nowrap;
      a {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        &:last-child {
          button {
            background-color: $success-color;
            color: #fff;
          }
        }
        button {
          padding: 10px;
          width: 100%;
          font-size: $button-size;
          border-radius: $border-radius;
          border: $border;
          outline: none;
          color: $font-color;
          background-color: white;
          box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
          i {
            font-size: 20px;
            margin-right: 5px;
          }
          &:hover {
            cursor: pointer;
            transition: all ease-in-out 0.3s;
            box-shadow: none;
          }
        }
      }
    }
  }
}

.promo-button {
  align-self: center;
  font-size: 16px;
  outline: none;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #1e90ff;
}

.promo-button:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.promo-form {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: $main-font;
  margin-top: 10px;

  .promo-input {
    height: 32px;
    border-radius: 5px;
    border: 1px solid $text-color2;
    outline: none;
    padding-left: 5px;
    color: $text-color;
    margin-right: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    width: 30%;
  }

  .promo-input:hover {
    border: 1px solid #1e90ff;
  }

  .promo-submit-btn {
    text-align: center;
    height: 32px;
    padding: 0px 5px;
    border-radius: 5px;
    background-color: #1e90ff;
    border: 1px solid #1e90ff;
    color: #fff;
    cursor: pointer;
    font-size: 13px;
    outline: none;
  }

  .promo-submit-btn:hover {
    border: 1px solid gray;
    background-color: #fff;
    color: gray;
  }
}

@media screen and (max-width: 1250px) {
  .breadcrumb {
    max-width: 50rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 46rem;
    .recommendation {
      .recommended-item {
        .cartList {
          .cartListInfo {
            margin: 0 30px;
            .cartListInfo-top {
              p {
                font-size: calc($text-size - 3px);
              }
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 940px) {
  .breadcrumb {
    max-width: 35rem;
    margin: 0px auto 20px;
  }
  main {
    max-width: 35rem;
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 718px) {
  .breadcrumb {
    ul {
      li {
        + li:before {
          padding: 2px;
        }
        a {
          padding: 5px;
          font-size: calc(var(--icon-size) - 4px);
        }
      }
    }
  }
  main {
    width: 90vw;
    margin: 0 auto;
    .main-left {
      .cart {
        width: 90vw;
        height: auto;
        max-height: 450px;
        .cartList {
          overflow-x: hidden;
          img {
            height: 50px;
            width: 50px;
          }
          .cartListInfo {
            margin: 0 0px 0 20px;
            // flex-basis: 0%;
            .cartListInfo-top {
              width: 10rem;
            }
            .cartListInfo-bottom {
              width: 100vw;
              position: relative;
              right: 90px;
              // background-color: rebeccapurple;
              .price {
                flex-basis: 30%;
              }
              .total {
                flex-basis: 60%;
                margin-left: 10px;
              }
            }
          }
          .remove-item {
            // background: #000;
            position: relative;
            right: 250px;
          }
        }
      }
      .recommendation {
        width: 90vw;
        .order-button-wrap {
          .add {
            position: relative;
            top: 50px;
          }
        }
      }
    }
  }
}

// old css
/* .cart-page {
  .head {
    .cart {
      font-size: 36px;
      span {
        display: none;
        &.show {
          display: inline-block;
        }
      }
    }
  }
  .empty {
    display: none;

    .img-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      margin: 30px;
      opacity: 0.7;
      width: initial;
      height: 212px;
    }
    .text-content {
      font-family: $main-font;
      color: #93959f;
      font-size: 14px;
      padding-top: 10px;
    }
    &.show {
      display: block;
    }
  }
  .cart-items-wrap {
    display: block;
    &.show {
      display: none;
    }
  }

  .header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    padding: 0 0 25px 0;
    margin-bottom: 30px;
    border-bottom: 1px solid #eaeaea;
    > div {
      font-family: $main-font;
      font-size: 16px;
      font-weight: 600;
      color: $text-color;
      margin: 0 15px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        text-align: right;
        margin-right: 0;
      }
    }
  }

  .cart-item-content {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    padding-bottom: 30px;
    > div {
      margin: 0 15px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
        min-width: 60px;
      }
    }
    .food-name {
      font-size: 16px;
    }
    .price {
      font-size: 15px;
    }
    .remove-item {
      text-align: right;
      i {
        color: red;
        cursor: pointer;
        font-size: 16px;
      }
    }
  }

  .subtotal {
    .total-price {
      padding-top: 30px;
      font-size: 18px;
      &.discount-info {
        padding-top: 10px;
        font-size: 14px;
      }
    }
    .extra-charge {
      font-size: 15px;
      margin-top: 10px;
    }
  }
} */

/* @media only screen and (max-width: 991px) {
  .cart-page {
    .header {
      grid-template-columns: 4fr 2fr 2fr 2fr 1fr;
      > div {
        font-size: 15px;
      }
      .item-action {
        span {
          display: none;
        }
      }
    }
    .cart-item-content {
      grid-template-columns: 4fr 2fr 2fr 2fr 1fr;
      .food-name {
        font-size: 14px;
      }
      .price {
        font-size: 14px;
      }
      .remove-item {
        i {
          font-size: 15px;
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .cart-page {
    .header {
      > div {
        font-size: 13px;
        margin: 0 5px;
      }
    }
    .cart-item-content > {
      div {
        margin: 0 5px;
        &.order-button-wrap {
          font-size: 12px;
          line-height: 28px;
          width: 60px;
          button {
            height: 20px;
            padding: 0 5px;
          }
        }
      }
      .food-name {
        font-size: 12px;
      }
      .price {
        font-size: 12px;
        text-align: center;
      }
    }
  }
} */

.total-price {
  font-weight: 600;
  line-height: 22px;
}
</style>
